import { APICall } from ".."

const ControllerName = "MobPatientMedicalServices"

export const GetAvailableServices = (hospitalId: number) => {
    return APICall("get", ControllerName + `/GetAvailableServices?hospitalId=${hospitalId}`)
}

export const GetPatientDecisions = (data: any) => {
    let keyword = data["keyword"]
    let textKeyword = data["textKeyword"]

    return APICall("get", ControllerName + `/GetPatientDecisions?keyword=${keyword||""}&textKeyword=${textKeyword||""}`)
}

export const GetPrevMdicalServices = (decisionId: number) => {
    return APICall("get", ControllerName + `/history/${decisionId}`)
}

export const SubmitNewMedicalServices = (data: any) => {
    return APICall("post", ControllerName + "/SubmitNewMedicalServices", data)
}
